import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { getInstrumenter } from "./instrumenter.js";
import { knownContextKeys } from "./tracingContext.js";
/**
 * Creates a new tracing client.
 *
 * @param options - Options used to configure the tracing client.
 * @returns - An instance of {@link TracingClient}.
 */

export function createTracingClient(options) {
  var namespace = options.namespace,
      packageName = options.packageName,
      packageVersion = options.packageVersion;

  function startSpan(name, operationOptions, spanOptions) {
    var _a;

    var startSpanResult = getInstrumenter().startSpan(name, Object.assign(Object.assign({}, spanOptions), {
      packageName: packageName,
      packageVersion: packageVersion,
      tracingContext: (_a = operationOptions === null || operationOptions === void 0 ? void 0 : operationOptions.tracingOptions) === null || _a === void 0 ? void 0 : _a.tracingContext
    }));
    var tracingContext = startSpanResult.tracingContext;
    var span = startSpanResult.span;

    if (!tracingContext.getValue(knownContextKeys.namespace)) {
      tracingContext = tracingContext.setValue(knownContextKeys.namespace, namespace);
    }

    span.setAttribute("az.namespace", tracingContext.getValue(knownContextKeys.namespace));
    var updatedOptions = Object.assign({}, operationOptions, {
      tracingOptions: Object.assign(Object.assign({}, operationOptions === null || operationOptions === void 0 ? void 0 : operationOptions.tracingOptions), {
        tracingContext: tracingContext
      })
    });
    return {
      span: span,
      updatedOptions: updatedOptions
    };
  }

  function withSpan(_x, _x2, _x3, _x4) {
    return _withSpan.apply(this, arguments);
  }

  function _withSpan() {
    _withSpan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, operationOptions, callback, spanOptions) {
      var _startSpan, span, updatedOptions, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _startSpan = startSpan(name, operationOptions, spanOptions), span = _startSpan.span, updatedOptions = _startSpan.updatedOptions;
              _context.prev = 1;
              _context.next = 4;
              return withContext(updatedOptions.tracingOptions.tracingContext, function () {
                return Promise.resolve(callback(updatedOptions, span));
              });

            case 4:
              result = _context.sent;
              span.setStatus({
                status: "success"
              });
              return _context.abrupt("return", result);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              span.setStatus({
                status: "error",
                error: _context.t0
              });
              throw _context.t0;

            case 13:
              _context.prev = 13;
              span.end();
              return _context.finish(13);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9, 13, 16]]);
    }));
    return _withSpan.apply(this, arguments);
  }

  function withContext(context, callback) {
    var _getInstrumenter;

    for (var _len = arguments.length, callbackArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      callbackArgs[_key - 2] = arguments[_key];
    }

    return (_getInstrumenter = getInstrumenter()).withContext.apply(_getInstrumenter, [context, callback].concat(callbackArgs));
  }
  /**
   * Parses a traceparent header value into a span identifier.
   *
   * @param traceparentHeader - The traceparent header to parse.
   * @returns An implementation-specific identifier for the span.
   */


  function parseTraceparentHeader(traceparentHeader) {
    return getInstrumenter().parseTraceparentHeader(traceparentHeader);
  }
  /**
   * Creates a set of request headers to propagate tracing information to a backend.
   *
   * @param tracingContext - The context containing the span to serialize.
   * @returns The set of headers to add to a request.
   */


  function createRequestHeaders(tracingContext) {
    return getInstrumenter().createRequestHeaders(tracingContext);
  }

  return {
    startSpan: startSpan,
    withSpan: withSpan,
    withContext: withContext,
    parseTraceparentHeader: parseTraceparentHeader,
    createRequestHeaders: createRequestHeaders
  };
}